import { render, staticRenderFns } from "./BulkCloseForm.vue?vue&type=template&id=37e9b2d5"
import script from "./BulkCloseForm.vue?vue&type=script&lang=js"
export * from "./BulkCloseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports